<template>
    <div>
      <!-- Header -->
      <div class="pageHeader page-header__flex">
        Participants<br>
      </div>
  
      <!-- Body -->
      <div class="body">
        <div>
            <themed-table 
                :headers="activeThemedTable.key && configThemedTables[activeThemedTable.key] ? configThemedTables[activeThemedTable.key].headers : []" 
                :data="transformedData" 
                :pagination="{
                    perPage: configThemedTables[activeThemedTable.key].query.limit,
                    total: configThemedTables[activeThemedTable.key].total
                }"
                :sortingEnabled=false 
                :filteringEnabled=false
                :paginationEnabled=true
                @paginationChange="(event) => {
                    configThemedTables[activeThemedTable.key].query.skip = configThemedTables[activeThemedTable.key].query.limit * (event.page - 1);
                    configThemedTables[activeThemedTable.key].query = {...configThemedTables[activeThemedTable.key].query};
                }"
                @searchChange="(event) => {
                    const query = configThemedTables[activeThemedTable.key].query;
                    query.skip = 0; // Resets skip as the search params change
                    Object.keys(event).forEach((key) => {
                        if (event[key] && event[key].length >= 3) query[key] = event[key];
                        else delete query[key];
                    })
                    
                    configThemedTables[activeThemedTable.key].query = {...query};
                }"
                ></themed-table>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import VueToast from "vue-toast-notification";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import ThemedTable from "../../../shared/careai/components/ThemedTable.vue";

  const moment = require("moment");
  
  Vue.use(VueToast);
  Vue.use(Loading);
  Vue.component('themed-table', ThemedTable);
  
  export default {
    name: "VirtualVisitParticipants",
    components: { },
    data() {
      return {
        console: console,
        jobsManager: this.$auth && this.$auth.user && this.$auth.user.hasOwnProperty('https://care.ai/permissions') && this.$auth.user['https://care.ai/permissions'].find((role) => role === "jobs:mgr") ? true : false,
        moment: moment,
        activeThemedTable: {
            key: 'participants',
        },
        configThemedTables: {
          participants: {
            query: {
              skip: 0,
              limit: 30,
              type: 'participant_connected',
            },
            headers: [
                {
                    key: 'conferenceId',
                    label: 'Conference ID',
                    sortable: false,
                    active: true,
                },                    {
                    key: 'participantId',
                    label: 'Participant ID',
                    sortable: false,
                    active: true,
                },
                {
                    key: 'participantCallTag',
                    label: 'Participant Call Tag',
                    sortable: false,
                    active: true,
                    searchLabel: 'Search by Participant Call Tag',
                    searchable: 'participantCallTag',
                },
                {
                    key: 'participantName',
                    label: 'Participant Name',
                    sortable: false,
                    active: true,
                    searchLabel: 'Search by Participant Name',
                    searchable: 'participantName',
                },
                {
                    key: 'conferenceLocked',
                    label: 'In Locked Coference',
                    sortable: false,
                    active: true,
                    searchable: false,
                },
                {
                    key: 'time',
                    label: 'Event Time',
                    sortable: false,
                    active: true,   
                    searchable: false,
                },
                {
                    key: 'actions',
                    label: 'Actions',
                    sortable: false,
                    active: true,
                    renderAsIcons: true,
                    searchable: false,
                },
            ],
            data: [],
          },
        }
      };
    },
    computed: {
      transformedData() {
        if (Array.isArray(this.configThemedTables.participants.data)) {
            this.configThemedTables.participants.data.forEach((item) => {
                if (item.time) {
                    item.time = moment(item.time).format("MMMM Do, YYYY [at] h:mm A");
                }
                item.icons = [{
                    slug: 'ban',
                    onClick: () => {
                        if (confirm("Ensure this participant is not in an active call. You can confirm in Pexip. Are you sure you want to proceed?")) {
                            this.patchParticipants(item.conferenceId, item.participantId);
                        }
                    },
                    tooltip: 'Manual disconnect.'
                }]
            })
        }
        return this.configThemedTables.participants.data;
      },
      currentQuery() {
        if (this.activeThemedTable.key && this.configThemedTables[this.activeThemedTable.key]) {
            return this.configThemedTables[this.activeThemedTable.key].query;
        }
        return null;
      },
    },
    watch: {
        currentQuery(newQuery, oldQuery) {
            this.searchParticipants();
        },
    },
    mounted() {
        this.searchParticipants();
    },
    unmounted() {},
    methods: {
      async searchParticipants() {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        const queryObject = { ...this.configThemedTables[this.activeThemedTable.key].query };
        const queryString = new URLSearchParams(queryObject).toString();
        var request = new Request(
        // eslint-disable-next-line no-undef
        config.OPERATIONS_SERVICE + `/participant-events?${queryString}`, 
        {
            method: 'GET',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
            Authorization: 'Bearer ' + id_token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            },
        }
        );

        // Attempt to get Gateways
        try {
            const response = await fetch(request);
            if (response.status === 403) {
                Vue.$toast.open({
                message: "Uh oh... You don't have the permission required to access this resource",
                type: 'error',
                });
                return;
            }
            if (response.status == 401) {
                Vue.$toast.open({
                message: 'Your session has expired please login again to continue',
                type: 'error',
                });
                return;
            }
            if ([502, 503].includes(response.status)) {
                this.searchParticipants();
            }
            if (response.status != 200) {
                Vue.$toast.open({
                message: 'Unable to get data',
                type: 'error',
                });
                return;
            } else {
                const participants = await response.json();
                this.configThemedTables.participants.data = participants.data;
                this.configThemedTables.participants.query.limit = participants.pagination.limit;
                this.configThemedTables.participants.total = participants.pagination.total;
            }
        } catch (tex) {
            Vue.$toast.open({message: 'Failed to search participants due to an error.', type: 'error'});
        }
      },
      async patchParticipants(conferenceId, participantId) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var request = new Request(
        // eslint-disable-next-line no-undef
        config.OPERATIONS_SERVICE + `/participant-disconnect/${conferenceId}/${participantId}`, 
        {
            method: 'PATCH',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
            Authorization: 'Bearer ' + id_token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            },
        }
        );

        // Attempt to get Gateways
        try {
            const response = await fetch(request);
            if (response.status === 403) {
                Vue.$toast.open({
                message: "Uh oh... You don't have the permission required to access this resource",
                type: 'error',
                });
                return;
            }
            if (response.status == 401) {
                Vue.$toast.open({
                message: 'Your session has expired please login again to continue',
                type: 'error',
                });
                return;
            }
            if ([502, 503].includes(response.status)) {
                this.patchParticipants(conferenceId, participantId, payload);
            }
            if (response.status != 200) {
                Vue.$toast.open({
                    message: 'Unable to patch data',
                    type: 'error',
                });
                return;
            } else {
                this.searchParticipants();
            }
        } catch (tex) {
            Vue.$toast.open({message: 'Failed to patch participant to an error.', type: 'error'});
        }
      },
    },
  };
  </script>
  
  <!-- Header Styles -->
  <style lang="scss" scoped>
    .page-header {
      &__flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
  
      &__statistics {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
  
      &__statistics-item {
        font-size: .7em;
        display: flex;
        flex-direction: column;
      }
    }

    .body {
        &__inner {
            padding: 15px;
        }
    }
  </style>  
  
  <style>
  ::-webkit-scrollbar {
    width: 6px; 
    height: 6px;
  }</style>
  